import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';
import UserCard from 'components/new_ui/Cards/UserCard';
import { useContext as useUsersContext } from 'components/Users/Context';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Modal from 'components/new_ui/Modal/Modal';
import ValueItem from 'components/Widgets/Profile/ValueItem';

import General from './Forms/General';
import Basic from './Forms/Basic';
import Company from './Forms/Company';
import Languages from './Forms/Languages';
import Password from './Forms/Password';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();
  const [formType, setFormType] = useState(null);

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (stateUsers.user === null) {
    return (
      <div className="content user-profile">
        <section>
          <h1>Profile</h1>
        </section>

        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  const openForm = (typeForm) => {
    setFormType(typeForm);
  };

  const manager = stateUsers.user.attributes.specific;

  return (
    <>
      <div className="content user-profile">
        <section>
          <h1>Profile</h1>
        </section>

        <section>
          <Row>
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="d-flex justify-content-between">
                <div className="block-title">Manager</div>
                <Button onClick={() => openForm('general')} variant="link">Edit</Button>
              </div>

              <UserCard
                avatar={manager.avatar}
                name={manager.full_name}
                position={manager.title}
              />

              <div className="d-flex justify-content-between mt-5">
                <div className="block-title">Basic Info</div>
                <Button onClick={() => openForm('basic')} variant="link">Edit</Button>
              </div>

              <ValueItem
                key="time-zone"
                icon="time-zone-icon"
                label="Time Zone"
              >
                {manager.time_zone}
              </ValueItem>

              <ValueItem
                key="phone"
                icon="phone-icon"
                label="Mobile Phone"
              >
                {manager.phone}
              </ValueItem>

              <ValueItem
                key="email"
                icon="email-icon"
                label="Work Email"
              >
                {manager.email}
              </ValueItem>

              <ValueItem
                key="address"
                icon="address-icon"
                label="Address"
              >
                {manager.full_address}
              </ValueItem>

              <ValueItem
                key="password"
                icon="password-icon"
                label="Password"
              >
                <Button onClick={() => openForm('password')} variant="link">Change password</Button>
              </ValueItem>
            </Col>

            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="d-flex justify-content-between">
                <div className="block-title">Company</div>
                <Button onClick={() => openForm('company')} variant="link">Edit</Button>
              </div>

              <ValueItem
                key="company"
                icon="company-icon"
                label="Company"
              >
                {manager.enterprise_name}
              </ValueItem>

              <ValueItem
                key="team-size"
                icon="team-size-icon"
                label="Size"
              >
                {manager.team_size}
              </ValueItem>

              <ValueItem
                key="industry"
                icon="company-industry-icon"
                label="Industry"
              >
                {manager.industry}
              </ValueItem>

              <ValueItem
                key="website"
                icon="web-icon"
                label="Website"
              >
                {manager.enterprise_website}
              </ValueItem>

              <div className="d-flex justify-content-between mt-5">
                <div className="block-title">Languages</div>
                <Button onClick={() => openForm('languages')} variant="link">Edit</Button>
              </div>

              {manager.languages.map((lang) => (
                <IconWithText
                  key={lang.id}
                  iconClassName="small-icon picture-icon"
                  iconStyle={{
                    backgroundImage: `url(${lang.flag})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                  }}
                  wrapperClassName="mt-3"
                >
                  {lang.title}
                </IconWithText>
              ))}
            </Col>
          </Row>
        </section>
      </div>

      <Modal size="lg" show={formType !== null}>
        {formType === 'general' && <General onCloseClick={() => setFormType(null)} />}
        {formType === 'basic' && <Basic onCloseClick={() => setFormType(null)} />}
        {formType === 'company' && <Company onCloseClick={() => setFormType(null)} />}
        {formType === 'languages' && <Languages onCloseClick={() => setFormType(null)} />}
        {formType === 'password' && <Password onCloseClick={() => setFormType(null)} />}
      </Modal>
    </>
  );
}
